import { AwardIcon, BellIcon, DownloadIcon, StarIcon, UserPlusIcon } from '@ramp106/omrjs-core-ui/icons'
import type { Component } from 'vue'

const CATEGORY_ICONS: [prefix: string, icon: Component][] = [
  ['omr.reviews.lead.whitepaper_download', DownloadIcon],
  ['omr.reviews.lead', UserPlusIcon],
  ['omr.reviews.review', StarIcon],
  ['omr.reviews.badge', AwardIcon],
]

export function notificationCategoryIcon(category: string): Component {
  const match = CATEGORY_ICONS.find(([prefix]) => category === prefix || category.startsWith(`${prefix}.`))
  return match?.[1] ?? BellIcon
}
